import React from 'react';

import { createStyles, Stack, Tabs } from '@mantine/core';

import Workout from './Workouts';
import WorkoutTemplates from './WorkoutTemplates';

const useStyles = createStyles(() => ({
  container: {
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
}));

const WorkoutLibrary = (): JSX.Element => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Stack spacing='md' sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <Tabs
          defaultValue='templates'
          variant='pills'
          keepMounted={false}
          styles={{
            root: { flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' },
            panel: { flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' },
          }}
        >
          <Tabs.List sx={{ width: 'fit-content' }}>
            <Tabs.Tab value='templates'>Workout Templates</Tabs.Tab>
            <Tabs.Tab value='workout'>Assigned Workouts</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value='templates' pt='xs'>
            <WorkoutTemplates />
          </Tabs.Panel>

          <Tabs.Panel value='workout' pt='xs'>
            <Workout />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </div>
  );
};

export default WorkoutLibrary;
